// extracted by mini-css-extract-plugin
module.exports = {"avatarBlock":"Avatar_avatarBlock__3-ckY","avatar":"Avatar_avatar__8oWI4","circelAvatar":"Avatar_circelAvatar__1Dt9I"};